import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row, Col, Typography, Card, Form, Button, notification,
} from 'antd';
import PropTypes from 'prop-types';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import DetailsFields from '../detailsFields/DetailsFields';
import {
  get, isSuperAgentError, RequestWrapper, ResponseWrapper,
} from '../../../../../dataSource/requests';
import './Details.scss';

const Details = (
  props,
): JSX.Element => {
  const {
    serviceRequestParameters, nextPage, previousPage,
  } = props;
  const navigate = useNavigate();
  const [formInstance] = Form.useForm();
  const [listModels, setListModels] = useState([
    { id: 0, name: 'Nenhum modelo encontrado' },
  ]);

  const handleSubmit = (values): void => {
    const fields = Object.entries(values);
    let verifyValorUnitario = formInstance.getFieldValue('POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO');
    let verifyValorTotal = formInstance.getFieldValue('POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL');
    const verifyCondicaoPagamento = formInstance.getFieldValue('POS_VENDA_ASSISTENCIA_TECNICA-CONDICAO_PAGAMENTO');
    const verifyFormaPagamento = formInstance.getFieldValue('POS_VENDA_ASSISTENCIA_TECNICA-FORMA_PAGAMENTO');

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        fields.forEach((item) => {
          const newItem = item;
          if (item[0] === 'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO') {
            newItem[1] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
          }

          if (item[0] === 'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL') {
            newItem[1] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
          }
        });
      } else {
        fields.forEach((item) => {
          const newItem = item;
          if (item[0] === 'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_UNITARIO') {
            newItem[1] = null;
          }

          if (item[0] === 'POS_VENDA_ASSISTENCIA_TECNICA-VALOR_TOTAL') {
            newItem[1] = null;
          }
        });
      }

      nextPage({
        ...serviceRequestParameters,
        serviceRequestFieldInputList: fields.map((fieldValue) => {
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1] || '',
          });
        }).filter((fieldValue) => {
          return fieldValue.value != null
            || fieldValue.idCode.includes('VALOR_UNITARIO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('OBSERVACOES');
        }),
      });
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
    }
  };

  const getAllEquipments = async (): Promise<void> => {
    let response: ResponseWrapper | undefined;
    let responseError: ResponseWrapper | undefined;
    let genericError: Error | undefined;

    const requestReference: RequestWrapper = get({
      url: '/equipament-model/listAll',

      frontConfigs: {
        navigateFunction: navigate,
      },
    });

    try {
      response = await requestReference;
    } catch (error: unknown) {
      if (isSuperAgentError(error)) {
        responseError = error.response;
      } else {
        genericError = error as Error;
      }
    }

    switch (true) {
      case (response?.body?.code === 14001):
        // "Equipament model listed successfully", 14001
        setListModels(response?.body.equipamentModels);
        break;

      case (responseError?.body?.code === -4001):
        // "You must be authenticated to perform this operation", -4001
        break;

      case (genericError?.message?.includes('has been aborted')):
        // dont show anything when request is aborted
        break;

      default:
        notification.error({
          message: 'Erro',
          description: 'Desculpe, houve um erro ao buscar a lista de modelos de equipamento, '
            + 'por favor tente novamente mais tarde',
        });
        break;
    }
  };

  useEffect(() => {
    getAllEquipments();

    return () => {
      setListModels([
        { id: 0, name: 'Nenhum modelo encontrado' },
      ]);
    };
  }, []);

  return (
    <div className="AssistenciaTecnicaDetails">
      <Row
        justify="space-between"
        className="AssistenciaTecnicaDetails__TitleRow"
      >
        <Col
          className="AssistenciaTecnicaDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="AssistenciaTecnicaDetails__Title"
          >
            Novo Serviço: Pós-vendas
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="AssistenciaTecnicaDetails__ContentRow"
      >
        <Col
          span={24}
          className="AssistenciaTecnicaDetails__ContentColumn"
        >
          <Card
            className="AssistenciaTecnicaDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="AssistenciaTecnicaDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="AssistenciaTecnicaDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="AssistenciaTecnicaDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo): void => {
                      console.log('AssistenciaTecnicaDetails onFinishFailed', errorInfo);
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                    mode="CREATE"
                    listModels={listModels}
                  />
                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="AssistenciaTecnicaDetails__LandAndSummaryColumn"
              >
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="AssistenciaTecnicaDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="AssistenciaTecnicaDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="AssistenciaTecnicaDetails__BackButton"
                  onClick={
                    (): void => {
                      previousPage();
                    }
                  }
                >
                  <ArrowLeftIcon className="AssistenciaTecnicaDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="AssistenciaTecnicaDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="AssistenciaTecnicaDetails__ContinueButton"
                  onClick={
                    (eventt): void => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.string,
    nameModel: PropTypes.string,
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
